import { MprcJoinComponents } from "components";
import { MprcFeedTypography } from "components/MprcFeedTypography";
import { FeedType, PublicationApprovalStatus } from "generated/CoreApi_v1";
import { useTranslation } from "react-i18next";
import { CardChannelLink } from "views/knowledge/components/card/behaviors/common/CardChannelLink";
import { useCardContext } from "../../CardBuilder";

///
export const DefaultModerationClassification = () => {
    const { pub, otherInfo } = useCardContext();
    const { t } = useTranslation("knowledge");

    const components: React.ReactNode[] = [];

    if (pub.approvalStatus != PublicationApprovalStatus.Approved) {
        components.push(
            <MprcFeedTypography variant="classification" color={pub.approvalStatus == PublicationApprovalStatus.Rejected ? "error" : undefined}>
                {pub.isDraft
                    ? t("Feed.Card.Common.DraftText")
                    : pub.approvalStatus == PublicationApprovalStatus.PendingCognitiveAnalysis || pub.approvalStatus == PublicationApprovalStatus.PendingModeratorAction
                        ? t("Feed.Card.Common.PendingApprovalText")
                        : t("Feed.Card.Common.PublicationRejectedText")
                }
            </MprcFeedTypography>
        );
    }

    if (pub.channel?.name && otherInfo?.feedType != FeedType.Channel)
        components.push(<MprcFeedTypography variant="classification"><CardChannelLink /></MprcFeedTypography>);

    if (components.length == 0) return null;

    return (
        <MprcFeedTypography variant="classification" noWrap component="div">
            <MprcJoinComponents separator="&bull;" components={components} />
        </MprcFeedTypography>
    );
};
